import { SHORTCUT_MAIN_PAGE_CONFIG_FIELDS } from '@@partner:graphql/shortcuts'
import { MainPageBlock, RemoteMainPageConfig } from '@@partner:types:app'
import { GQL_ID } from '@@partner:types:graphql'
import { gql, useMutation } from '@apollo/client'

export type MainPageBlockInput = Omit<MainPageBlock, 'payload'> & {
  payload?: string | null
}

export interface MainPageConfigInfoInput {
  id?: GQL_ID
  is_active: boolean
  name: string
  activeFrom: number | null
  activeUntil: number | null
  blocks: MainPageBlockInput[]
}

export interface SaveMainPageConfig {
  updateMainPageConfig: RemoteMainPageConfig
}

export const GQL_MUTATION_SAVE_MAIN_PAGE_CONFIG = gql`
  mutation updateMainPageConfig ($newData: MainPageConfigInfoInput!, $upsert: Boolean!) {
    updateMainPageConfig(newData: $newData, upsert: $upsert) {
      ${SHORTCUT_MAIN_PAGE_CONFIG_FIELDS}
    }
  }
`

export const useMutateSaveMainPageConfig = () =>
  useMutation<SaveMainPageConfig, { newData: MainPageConfigInfoInput; upsert?: boolean }>(
    GQL_MUTATION_SAVE_MAIN_PAGE_CONFIG
  )